/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Ticketssalesuntil2Inputs */

const en_ticketssalesuntil2 = /** @type {(inputs: Ticketssalesuntil2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sales until ${i?.date}`)
};

const de_ticketssalesuntil2 = /** @type {(inputs: Ticketssalesuntil2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verkauf bis ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Sales until {date}" |
*
* @param {Ticketssalesuntil2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketssalesuntil2 = /** @type {((inputs: Ticketssalesuntil2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketssalesuntil2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketssalesuntil2(inputs)
	return de_ticketssalesuntil2(inputs)
});
export { ticketssalesuntil2 as "ticketsSalesUntil" }